import { Link, useLocation } from "react-router-dom";
import Seo from "@/components/feature/Seo";
import SiteLayout from "@/components/feature/SiteLayout";

export default function NotFound() {
  const location = useLocation();

  return (
    <>
      <Seo
        title="页面不存在｜瓜田福利社"
        description="你访问的页面不存在或已被调整，可以返回首页或浏览吃瓜合集继续阅读。"
        keywords="瓜田福利社,页面不存在"
        path="/"
      />
      <SiteLayout>
        <section className="flex w-full flex-col items-center gap-5 px-4 py-24 text-center md:px-6 md:py-32">
          <span className="font-heading text-7xl text-primary-200 md:text-9xl">404</span>
          <h1 className="font-heading text-3xl text-foreground-950">这个页面走丢了</h1>
          <p className="max-w-md text-sm leading-relaxed text-foreground-600">
            你访问的路径 <span className="font-mono text-foreground-800">{location.pathname}</span>
            {" "}可能已调整或尚未生成。回到首页或合集列表继续逛逛吧。
          </p>
          <div className="flex flex-col gap-3 sm:flex-row">
            <Link
              to="/"
              className="whitespace-nowrap rounded-full bg-foreground-950 px-6 py-3 text-sm font-label text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
            >
              返回首页
            </Link>
            <Link
              to="/gossip"
              className="whitespace-nowrap rounded-full border border-background-300 px-6 py-3 text-sm font-label text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600 cursor-pointer"
            >
              浏览吃瓜合集
            </Link>
          </div>
        </section>
      </SiteLayout>
    </>
  );
}